import { render, staticRenderFns } from "./Self_Assessment_Activity.vue?vue&type=template&id=442f2b89"
import script from "./Self_Assessment_Activity.vue?vue&type=script&lang=js"
export * from "./Self_Assessment_Activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports